module.exports = __webpack_public_path__ + "img/nunito-sans-v6-latin-900.ea695f6b.svg";